module.exports = __webpack_public_path__ + "static/img/wxBind.522c56d.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/wxBind.png
// module id = 1201
// module chunks = 18